import $ from 'jquery';
import cartItemErrors from '../templates/cartItemErrors.hbs';
import {
    ALERT_MESSAGE_CLASS,
    ERROR_MESSAGE_CLASS,
    IS_HIDDEN,
    LOADING_CLASS,
    SUCCESS_MESSAGE_CLASS
} from '../constants/classes';
import Notifications from '../global/Notifications';
import outOfStockErrors from '../templates/outOfStockErrors.hbs';
import TrackingService from '../services/TrackingService';


const SELECTORS = {
    CART_TABLE: '#cartTable',
    CART_ITEMS: '.js-cartController-item',
    ACTIVE_CART_ITEMS: '.js-cartController-item:not(.removed)',
    REMOVED_CART_ITEMS: '.js-cartController-item',
    PRODUCT_TITLE: '.js-cartController-item-productTitle',
    ITEM_QTY_INPUT: '.js-cartController-qty',
    ITEM_IN_STOCK_INLINE_ERROR: '.js-items-in-stock-error',
    ITEM_OUT_OF_STOCK_INLINE_ERROR: '.js-items-out-of-stock-error',
    CART_TABLE_ROW_CELL_CONTENT: '.cartTable-body-row-cell-content',
    ITEM_REMOVAL_LINK: '.js-cartController-remove',
    ITEM_UPDATE_LINK: '.js-cartController-update',
    ITEM_UNDO_REMOVAL_LINK: '.js-cartController-undoRemoval',
    CART_EMPTY_LINK: '.js-cartController-empty',
    CART_EMPTY_MODAL: '.js-cartController-emptyModal',
    CART_EMPTY_CONFIRM_LINK: '.js-cartController-emptyConfirm',
    ARIA_UPDATE: '.js-cartController-update-callout',
    SUBTOTAL: '.js-cartController-subtotal',
    DISCOUNT_TOTAL: '.js-cartController-discountTotal',
    CART_COUNT: '.js-cartCount',
    CART_COUNT_LABEL: '.js-cartCount-label',
    CART_CHECKOUT: '.js-cartController-checkout',
    DISCOUNTS_LABEL: '#DiscountTotal',
    SUBTOTAL_LABEL: '#Subtotal',
    MSG_DISPLAY: '.msg-display',
    CART_SHARE_LINK: '.js-cartController-share',
    CART_SHARE_MODAL: '.js-cartController-shareModal',
    CART_SHARE_COPY_URL: '.js-cartController-shareUrl',
    CART_SHARE_SEND_EMAIL: '.js-cartController-shareEmail',
    CART_SHARE_URL_MODAL: '.js-cartController-shareUrlModal',
    CART_SHARE_URL_INPUT: '.js-cartController-shareUrlInput',
    CART_SHARE_EMAIL_MODAL: '.js-cartController-shareEmailModal',
    CART_SHARE_EMAIL_CLOSE_BUTON: '.js-cartController-shareCartCloseButton',
    CART_SHARE_EMAIL_RECIPIENT_EMAIL: '.js-cartController-shareRecipientEmail',
    CART_SHARE_EMAIL_SENDER_NAME: '.js-cartController-shareSenderName',
    CART_SHARE_EMAIL_SENDER_EMAIL: '.js-cartController-shareSenderEmail',
    CART_SHARE_EMAIL_MESSAGE_BODY: '.js-cartController-shareMessageBody',
    CART_SHARE_EMAIL_SEND_BUTON: '.js-cartController-shareCartSendButton'
};

const CLASSES = {
    REMOVED_ITEM_CLASS: 'removed',
    INPUT_QTY_ERROR: 'input_squared--error',
    SITE_MESSAGE_ERROR: 'siteMessage_error',
    ICON_LINK_ATTENTION: 'iconLink_attention',
    BTN_DISABLED: 'btn_disabled'
}

const VALUES = {
    MAX_CART_ITEM_QTY: 250,
    CART_JS_VARIABLE: 'js_userCart'
}

export default class CartView {
    constructor($element, controller) {
        this.cartController = controller;
        this.cartService = this.cartController.cartService;
        this.cartModel = this.cartController.cartModel;
        this.trackingService = new TrackingService();
        this.init($element);
    }

    init($element) {
        this.$element = $element;

        return this.setupHandlers()
            .createChildren()
            .layout()
            .enable()
            .trackCartViewed();
    }

    setupHandlers() {
        this.onQuantityChangeHandler = this.onQuantityChange.bind(this);
        this.onQuantityKeydownHandler = this.onQuantityKeydown.bind(this);
        this.onUpdateClickHandler = this.onUpdateClick.bind(this);
        this.onItemRemovalHandler = this.onItemRemoval.bind(this);
        this.onCartEmptyHandler = this.onCartEmpty.bind(this);
        this.onCartEmptyConfirmHandler = this.onCartEmptyConfirm.bind(this);
        this.onCartShareHandler = this.onCartShare.bind(this);
        this.onCartShareCopyLinkHandler = this.onCartShareCopyLink.bind(this);
        this.onCartShareSendEmailHandler = this.onCartShareSendEmail.bind(this);
        this.onCartShareSendEmailCloseHandler = this.onCartShareSendEmailClose.bind(this);
        this.onCartShareSendEmailSubmitHandler = this.onCartShareSendEmailSubmit.bind(this);
        this.onClickOutHandler = this.onClickOut.bind(this);
        this.onUndoRemovalHandler = this.onUndoRemoval.bind(this);
        this.onCheckoutClickHandler = this.onCheckoutClick.bind(this);
        this.checkoutValidation = this.checkoutValidation.bind(this);
        return this;
    }

    createChildren() {
        this.createDynamicChildren();
        this.cartData = window[VALUES.CART_JS_VARIABLE];
        this.$cartTable = this.$element.find(SELECTORS.CART_TABLE);
        this.$cartItems = this.$element.find(SELECTORS.CART_ITEMS);
        this.$undoRemovalLinks = this.$cartItems.find(SELECTORS.ITEM_UNDO_REMOVAL_LINK);
        this.notifications = new Notifications();
        this.$subtotal = this.$element.find(SELECTORS.SUBTOTAL);
        this.$discountTotal = this.$element.find(SELECTORS.DISCOUNT_TOTAL);
        this.$discountsLabel = this.$element.find(SELECTORS.DISCOUNTS_LABEL);
        this.$subtotalLabel = this.$element.find(SELECTORS.SUBTOTAL_LABEL);
        this.$cartCount = $(SELECTORS.CART_COUNT);
        this.$cartCountLabel = this.$cartCount.find(SELECTORS.CART_COUNT_LABEL);
        this.$checkout = this.$element.find(SELECTORS.CART_CHECKOUT);
        this.cartModel.createCartArray(this.$activeCartItems);
        this.$ariaUpdate = this.$element.find(SELECTORS.ARIA_UPDATE);
        
        this.$cartEmptyLink = this.$element.find(SELECTORS.CART_EMPTY_LINK);
        this.$cartEmptyModal = this.$element.find(SELECTORS.CART_EMPTY_MODAL);
        this.$cartEmptyConfirmLink = this.$element.find(SELECTORS.CART_EMPTY_CONFIRM_LINK);

        this.$cartShareLink = this.$element.find(SELECTORS.CART_SHARE_LINK);
        this.$cartShareModal = this.$element.find(SELECTORS.CART_SHARE_MODAL);
        this.$cartShareCopyUrlLink = this.$element.find(SELECTORS.CART_SHARE_COPY_URL);
        this.$cartShareSendEmailLink = this.$element.find(SELECTORS.CART_SHARE_SEND_EMAIL);
        this.$cartShareUrlModal = this.$element.find(SELECTORS.CART_SHARE_URL_MODAL);
        this.$cartShareUrlInput = this.$element.find(SELECTORS.CART_SHARE_URL_INPUT);
        this.$cartShareEmailModal = this.$element.find(SELECTORS.CART_SHARE_EMAIL_MODAL);
        this.$cartShareEmailCloseButton = this.$element.find(SELECTORS.CART_SHARE_EMAIL_CLOSE_BUTON);
        this.$cartShareEmailRecipientEmail = this.$element.find(SELECTORS.CART_SHARE_EMAIL_RECIPIENT_EMAIL);
        this.$cartShareEmailSenderName = this.$element.find(SELECTORS.CART_SHARE_EMAIL_SENDER_NAME);
        this.$cartShareEmalSenderEmail = this.$element.find(SELECTORS.CART_SHARE_EMAIL_SENDER_EMAIL);
        this.$cartShareEmailMessageBody = this.$element.find(SELECTORS.CART_SHARE_EMAIL_MESSAGE_BODY);
        this.$cartShareEmailSendButton = this.$element.find(SELECTORS.CART_SHARE_EMAIL_SEND_BUTON);
    
        return this;
    }

    trackCartViewed(){
        this.trackingService.viewCart(this.cartData);
        return this;
    }

    onCartEmpty(e) {
        this.$cartEmptyModal.show();
    }

    async onCartEmptyConfirm(e) {
        const response = await this.cartService.emptyCart();
        if (!response.success) {
            return this.notifications.showErrorNotification(response.error, ALERT_MESSAGE_CLASS);
        }
        else {
            this.trackingService.removeAllFromCart(this.cartData);
            window.location = window.location.pathname;
        }
    }

    onCartShare(e) {
        this.$cartShareModal.removeClass(IS_HIDDEN);
    }

    async onCartShareCopyLink(e) {
        this.$cartShareCopyUrlLink.addClass(LOADING_CLASS);

        try {
            const response = await this.cartService.getSharedCartUrl();
            if (response.success) {
                this.$cartShareUrlInput[0].value = response.url;
                await this.copyShareLinkToClipboard(response.url);
            } else {
                this.notifications.showErrorNotification(response.error, ALERT_MESSAGE_CLASS);
            }
        }
        finally {
            this.$cartShareCopyUrlLink.removeClass(LOADING_CLASS);
        }
    }

    async copyShareLinkToClipboard(url) {
        if (navigator.clipboard) {
            try {
                await navigator.clipboard.writeText(url) 
                this.notifications.showErrorNotification('Link copied to clipboard!', SUCCESS_MESSAGE_CLASS);
                this.hideCartShareModal();
            }
            catch(ex) {
                this.showCartShareUrl(ex)
            }
        } else {
            this.showCartShareUrl()
        }
    }

    hideCartShareModal() {
        this.$cartShareModal.addClass(IS_HIDDEN);
    }

    showCartShareUrl(ex) {
        this.$cartShareUrlModal.removeClass(IS_HIDDEN);
        this.notifications.showErrorNotification('Could not copy link to clipboard.', ALERT_MESSAGE_CLASS);
    }

    async onCartShareSendEmail(e) {
        this.$cartShareEmailModal.removeClass(IS_HIDDEN);
        this.hideCartShareModal();
    }

    onCartShareSendEmailClose(e) {
        this.hideCartShareEmailModal();
    }

    hideCartShareEmailModal() {
        this.$cartShareEmailModal.addClass(IS_HIDDEN);
    }

    async onCartShareSendEmailSubmit(e) {
        const recipientEmail = this.$cartShareEmailRecipientEmail[0].value;
        const senderName = this.$cartShareEmailSenderName[0].value;
        const senderEmail = this.$cartShareEmalSenderEmail[0].value;
        const messageBody = this.$cartShareEmailMessageBody[0].value;

        if (!recipientEmail || !senderName || !senderEmail) {
            this.notifications.showErrorNotification('Please enter all required values.', ALERT_MESSAGE_CLASS);
            return;
        }

        this.$cartShareEmailSendButton.addClass(LOADING_CLASS);
        const shareObject = {
            recipientEmail: recipientEmail,
            senderName: senderName,
            senderEmail: senderEmail,
            messageBody: messageBody
        }

        try {
            const response = await this.cartService.sendSharedCartEmail(shareObject);
            if (response.success) {
                this.notifications.showErrorNotification('Email sent!', SUCCESS_MESSAGE_CLASS);
                this.hideCartShareEmailModal();
                this.$cartShareEmailRecipientEmail[0].value = '';
            } else {
                this.notifications.showErrorNotification(response.error, ALERT_MESSAGE_CLASS);
            }
        }
        finally {
            this.$cartShareEmailSendButton.removeClass(LOADING_CLASS);
        }
    }

    onClickOut(e) {
        if (!this.isClickTarget(e.target, SELECTORS.CART_EMPTY_MODAL) && !this.isClickTarget(e.target, SELECTORS.CART_EMPTY_LINK)) {
            this.$cartEmptyModal.hide();
        }

        if (!this.isClickTarget(e.target, SELECTORS.CART_SHARE_MODAL) && !this.isClickTarget(e.target, SELECTORS.CART_SHARE_LINK)) {
            this.hideCartShareModal(e);
        }

        if (!this.isClickTarget(e.target, SELECTORS.CART_SHARE_URL_MODAL) && !this.isClickTarget(e.target, SELECTORS.CART_SHARE_COPY_URL)) {
            this.$cartShareUrlModal.addClass(IS_HIDDEN);
        }

        if (!this.isClickTarget(e.target, SELECTORS.CART_SHARE_EMAIL_MODAL) && !this.isClickTarget(e.target, SELECTORS.CART_SHARE_SEND_EMAIL)) {
            this.hideCartShareEmailModal();
        }
    }

    isClickTarget(target, selector) {
        return $(target).closest(selector).length;
    }

    createDynamicChildren() {
        this.$activeCartItems = this.$element.find(SELECTORS.ACTIVE_CART_ITEMS);
        this.$updateLinks = this.$activeCartItems.find(SELECTORS.ITEM_UPDATE_LINK);
        this.$itemRemovalLinks = this.$activeCartItems.find(SELECTORS.ITEM_REMOVAL_LINK);
        this.$quantityInputs = this.$activeCartItems.find(SELECTORS.ITEM_QTY_INPUT);
        this.$inactiveCartItems = this.$element.find(SELECTORS.INACTIVE_CART_ITEMS);
        return this;
    }

    layout() {

        return this;
    }

    onQuantityChange(e) {
        const id = e.target.dataset.productId; /* corresponds to data-product-id="" which exists on target */
        const qty = this.$quantityInputs.filter('[data-product-id="' + id + '"]')[0].value;
        const updateLink = this.$updateLinks.filter('[data-product-id="' + id + '"]');
        this.cartModel.updateTrackingArray(id, qty);

        /* Adding active state change class to the updatelinks to show it's been changed */
        for (let i = 0; i < this.cartModel.cartArray.length; i++) {
            if (this.cartModel.cartArray[i].id === id) {
                if (this.cartModel.cartArray[i].qty !== parseInt(qty)) {
                    updateLink.addClass(CLASSES.ICON_LINK_ATTENTION);
                    setTimeout(() => {
                        this.$ariaUpdate.text(NOTIFICATIONS.UPDATE_QUANTITY_PROMPT);
                    }, 250);
                } else {
                    updateLink.removeClass(CLASSES.ICON_LINK_ATTENTION);
                }
            }
        }

        return this;
    }

     onQuantityKeydown(event) {
        if (event && event.originalEvent && event.originalEvent.key && event.originalEvent.key.toLowerCase() === "enter") {
            const id = event.target.dataset.productId; 
            const updateLinks = this.$updateLinks.filter('[data-product-id="' + id + '"]');
            if (updateLinks && updateLinks.length > 0) {
                /* set the event target to the update link element corresponding to the updated product 
                    to ensure proper update behavior */
                event.target = updateLinks[0];
                this.onUpdateClick(event);
            }
        }
    }

    checkoutValidation() {
        let validationError = false;
        this.$quantityInputs.each((_, node) => {
            const { qtyInStock, isOutOfStock } = node.dataset

            if ( isOutOfStock.toLowerCase()  === 'true' ) {
                validationError = true
                return
            } else if ( node.dataset.maxOrderQuantity && parseInt(node.value) > parseInt(node.dataset.maxOrderQuantity) ) {
                validationError = true
                return
            } else if ( parseInt(node.value) > parseInt(qtyInStock) ) {
                validationError = true
                return          
            }
        })
        if (!validationError) {
            this.$checkout.removeAttr('disabled');
        }
        return
    }

    async onUpdateClick(e) {
        const event = e;

        /* Adds overlay and spins item refresh icon */
        $(event.target).addClass(LOADING_CLASS);
        setTimeout(() => {
            this.$ariaUpdate.text(NOTIFICATIONS.CART_BUSY);
        }, 250);

        const updateObject = {};
        const id = event.target.dataset.productId; /* corresponds to data-product-id="" which exists on target */
        const $cartItem = this.$cartItems.filter('[id="' + id + '"]');
        const $productTitle = $cartItem.find(SELECTORS.PRODUCT_TITLE).text();

        const productCode = $cartItem.find(SELECTORS.ITEM_UNDO_REMOVAL_LINK)[0].dataset.productCode;
        const updateLink = this.$updateLinks.filter('[data-product-id="' + id + '"]');
        const inputNode = this.$quantityInputs.filter('[data-product-id="' + id + '"]');
        const inputValue = this.$quantityInputs.filter('[data-product-id="' + id + '"]')[0].value;
        const updateButton = $(event.target);
        var newQuantity = parseInt(inputValue)
        updateObject.qty = newQuantity;
        updateObject.productCode = productCode;
        // group number can change if item is removed & re-added to the cart, so we need to use the cart model value
        updateObject.entryGroupNumber =this.findPropById(id, this.cartModel.cartArray, 'entryGroupNumber'); ;
        updateObject.productId = id;

        if (this._isEmptyString(event, inputValue, id, $productTitle)) {
            return;
        }

        if (this._wasUpdatedToZero(event, updateObject.qty, id)) {
            return;
        }

        if (this._isOverMaxQty(event, updateObject.qty, id, $productTitle)) {
            return;
        } else {
            this.notifications.resetMessages();
        }

        try {
            const response = await this.cartService.updateCart(updateObject);
            if (!response.success && response.statuscode == 500) {
                return this.notifications.showErrorNotification(response.error, ALERT_MESSAGE_CLASS);
            }
            const { Entries } = response.updatedCart
            const updatedProductData = Entries.find((entry) => entry.Product.Code === productCode && entry.CartItemId === parseInt(id) )
            if (updatedProductData && updatedProductData.Product.MaxOrderQuantity && updateObject.qty > parseInt(updatedProductData.Product.MaxOrderQuantity )) {
                this.$checkout.attr('disabled', true);
                this.notifications.showErrorNotification(outOfStockErrors({message: NOTIFICATIONS.MORE_THAN_MAX_ORDERED_QUANTITY}), CLASSES.SITE_MESSAGE_ERROR);
            } else if (updatedProductData && updatedProductData.Product && updatedProductData.Product.Stock) {
                const { StockLevel, StockLevelStatus } = updatedProductData.Product.Stock
                const { ProductReference } = updatedProductData.Product
                let minimumStockLevel = parseInt(StockLevel)
                if (ProductReference && ProductReference.Stock && ProductReference.Stock.StockLevel) {
                    minimumStockLevel =Math.min(parseInt(StockLevel), parseInt(ProductReference.Stock.StockLevel))
                }
                if (StockLevelStatus === 'outOfStock') {
                    inputNode.parents(SELECTORS.CART_TABLE_ROW_CELL_CONTENT).find(SELECTORS.ITEM_OUT_OF_STOCK_INLINE_ERROR).removeClass(IS_HIDDEN);
                    this.$checkout.attr('disabled', true);
                    updateButton.addClass(CLASSES.BTN_DISABLED);
                    updateButton.attr('disabled', true);
                } else if (updateObject.qty > parseInt(minimumStockLevel)) {
                    const inlineErrorNode = inputNode.parents(SELECTORS.CART_TABLE_ROW_CELL_CONTENT).find(SELECTORS.ITEM_IN_STOCK_INLINE_ERROR)
                    inlineErrorNode.text(`Only ${minimumStockLevel} items in-stock.`)
                    inlineErrorNode.removeClass(IS_HIDDEN);
                    inputNode.addClass(CLASSES.INPUT_QTY_ERROR);
                    this.$checkout.attr('disabled', true);
                } else {
                    inputNode.parents(SELECTORS.CART_TABLE_ROW_CELL_CONTENT).find(SELECTORS.ITEM_OUT_OF_STOCK_INLINE_ERROR).addClass(IS_HIDDEN);
                    inputNode.parents(SELECTORS.CART_TABLE_ROW_CELL_CONTENT).find(SELECTORS.ITEM_IN_STOCK_INLINE_ERROR).addClass(IS_HIDDEN);
                    inputNode.removeClass(CLASSES.INPUT_QTY_ERROR);
                }
            }
            this.checkoutValidation()
            
            this.updateNavigationView(productCode, newQuantity);
            this.cartModel.updateCartArray(id, updateObject);

            $(e.target).removeClass(LOADING_CLASS);

            this.updateSubtotal(response.updatedCart.SubTotal);
            this.updateDiscountTotal(response.updatedCart.DiscountTotal);
            this.updateCartTotal(response.updatedCart.TotalQty);
            updateLink.removeClass(CLASSES.ICON_LINK_ATTENTION);

            this.hideExistingErrorOrNot();
            if (!response.success) { /* for other 200 non-success states (example: only certain number of products available) */
                this.notifications.showErrorNotification(response.error, ERROR_MESSAGE_CLASS);
                this.$quantityInputs.filter('[data-product-id="' + id + '"]')[0].value = response.qtyAdded;
                if (response.errorType === 'outOfStock') {
                    inputNode.parents(SELECTORS.CART_TABLE_ROW_CELL_CONTENT).find(SELECTORS.ITEM_OUT_OF_STOCK_INLINE_ERROR).removeClass(IS_HIDDEN);
                    this.$checkout.attr('disabled', true);
                    updateButton.addClass(CLASSES.BTN_DISABLED);
                    updateButton.attr('disabled', true);
                    inputNode.attr('data-out-of-stock-error', true);
                }
                if (response.errorType === 'exceededMaxOrderQuantity') {
                    this.$checkout.attr('disabled', true);
                }
                updateButton.removeClass(LOADING_CLASS);
            }
            setTimeout(() => {
                this.$ariaUpdate.text($productTitle + ': ' + NOTIFICATIONS.QTY_UPDATED + ' ' + this._provideCartTotalsUpdate());
            }, 500);

        } catch (e) {
            setTimeout(() => {
                $(event.target).removeClass(LOADING_CLASS);
                this.$ariaUpdate.text('');
                this.notifications.showErrorNotification(NOTIFICATIONS.FETCH_FAILED, ALERT_MESSAGE_CLASS);
            }, 500);
        }

    }

    _provideCartTotalsUpdate() {
        const discountLabel = this.$discountsLabel.text();
        const discounts = this.ariaDiscounts;
        const subtotalLabel = this.$subtotalLabel.text();
        const subtotal = this.ariaSubtotal;
        const cartCountLabel = this.$cartCountLabel.text();
        const cartCount = this.ariaCartCount;
        const status = `${cartCountLabel} ${cartCount}, ${subtotalLabel}: ${subtotal}, ${discountLabel}: ${discounts}`;

        return status;
    }

    hideExistingErrorOrNot() {
        const arrayOfChangedItems = this.getUnsavedItemChanges();
        if (arrayOfChangedItems.length) {
            const templateData = {
                notificationMessage: NOTIFICATIONS.FORGOT_TO_SAVE,
                product: arrayOfChangedItems
            };
            this.notifications.showErrorNotification(cartItemErrors(templateData));
            return;
        }

        this.notifications.resetMessages();
    }

    _isOverMaxQty(event, qty, id, $productTitle) {

        if (qty > VALUES.MAX_CART_ITEM_QTY) {
            const errorItem = {};
            errorItem.id = id;
            errorItem.title = $productTitle;
            let errorsArray = [];
            errorsArray.push(errorItem);

            const templateData = {
                notificationMessage: NOTIFICATIONS.MAX_QTY_ERROR,
                product: errorsArray
            };

            this.notifications.showErrorNotification(cartItemErrors(templateData), ERROR_MESSAGE_CLASS);
            $(event.target).removeClass(LOADING_CLASS);
            this.$ariaUpdate.text('');
            return true;
        }

        return false;
    }

    _isEmptyString(event, value, id, $productTitle) {
        if (value == "") {
            const errorItem = {};
            errorItem.id = id;
            errorItem.title = $productTitle;
            let errorsArray = [];
            errorsArray.push(errorItem);

            const templateData = {
                notificationMessage: NOTIFICATIONS.EMPTY_STRING,
                product: errorsArray
            };

            this.notifications.showErrorNotification(cartItemErrors(templateData), ERROR_MESSAGE_CLASS);
            $(event.target).removeClass(LOADING_CLASS);
            setTimeout(() => {
                this.$ariaUpdate.text(NOTIFICATIONS.CART_BUSY);
            }, 250);
            return true;
        }
        return false;
    }

    _wasUpdatedToZero(event, qty, id) {
        if (qty === 0) {
            $(event.target).removeClass(LOADING_CLASS);
            this.$ariaUpdate.text('');
            this.onItemRemovalHandler(event);
            return true;
        }

        return false;
    }

    async onItemRemoval(e) {
        const event = e;
        const id = event.target.dataset.productId; /* corresponds to data-product-id="" which exists on target */
        const $cartItem = this.$cartItems.filter('[id="' + id + '"]');
        const $productTitle = $cartItem.find(SELECTORS.PRODUCT_TITLE).text();
        const inputNode = this.$quantityInputs.filter('[data-product-id="' + id + '"]')[0];

        const undoRemovalLink = $cartItem.find(SELECTORS.ITEM_UNDO_REMOVAL_LINK)[0];
        const productCode = undoRemovalLink.dataset.productCode;
        const updateLink = this.$updateLinks.filter('[data-product-id="' + id + '"]');
        const prevObject = {} /* For storing previous item state for reapplication if they undo removal */
        const updateObject = {};

        if (inputNode.dataset.outOfStockError && inputNode.dataset.outOfStockError === 'true') {
            window.location.reload();
            return
        }
        prevObject.id = id;
        prevObject.qty = this.findPropById(id, this.cartModel.cartArray, 'qty');
        updateObject.qty = 0;
        updateObject.productCode = productCode;
        updateObject.productId = id;
        // group number can change if item is removed & re-added to the cart, so we need to use the cart model value
        updateObject.entryGroupNumber = this.findPropById(id, this.cartModel.cartArray, 'entryGroupNumber'); ;

        /* Adds overlay and spins item refresh icon */
        updateLink.addClass(LOADING_CLASS);
        setTimeout(() => {
            this.$ariaUpdate.text(NOTIFICATIONS.CART_BUSY);
        }, 250);

        try {
            const response = await this.cartService.updateCart(updateObject);

            if (!response.success && response.statuscode == 500) {
                return this.notifications.showErrorNotification(response.error, ALERT_MESSAGE_CLASS);
            }

            this.updateNavigationView(productCode, 0);
            this.cartModel.updateCartArray(id, updateObject);
            this.$activeCartItems.filter('[id="' + id + '"]').addClass(CLASSES.REMOVED_ITEM_CLASS);

            updateLink.removeClass(LOADING_CLASS);

            $cartItem.find(SELECTORS.MSG_DISPLAY).addClass(IS_HIDDEN)
            this.createDynamicChildren(); /* Reestablishing active children after removal */
            this.cartModel.addToRemovedItemArray(prevObject); /* Storing previous item state */
            this.updateSubtotal(response.updatedCart.SubTotal);
            this.updateDiscountTotal(response.updatedCart.DiscountTotal);
            this.updateCartTotal(response.updatedCart.TotalQty);
            updateLink.removeClass(CLASSES.ICON_LINK_ATTENTION);
            this.hideExistingErrorOrNot();
            this.checkoutValidation();
            setTimeout(() => {
                undoRemovalLink.focus(); /* Applying focus on the undo removal link */
            }, 500);
            setTimeout(() => {
                this.$ariaUpdate.text($productTitle + ': ' + NOTIFICATIONS.ITEM_REMOVED + ' ' + this._provideCartTotalsUpdate());
            }, 1000)
        } catch (e) {
            setTimeout(() => {
                updateLink.removeClass(LOADING_CLASS);
                this.$ariaUpdate.text('');

                this.notifications.showErrorNotification(NOTIFICATIONS.FETCH_FAILED, ALERT_MESSAGE_CLASS);
                this.createDynamicChildren();
            }, 500)
        }
    }

    findPropById(id, array, prop) {
        for (let i = 0; i < array.length; i++) {
            if (array[i].id == id) {
                return array[i][prop];
            }
        }
    }

    async onUndoRemoval(e) {
        const event = e;
        const $target = $(event.target);

        /* Adding loading classes. Adds overlay and spins item refresh icon */
        $target.addClass(LOADING_CLASS);
        setTimeout(() => {
            this.$ariaUpdate.text(NOTIFICATIONS.CART_BUSY);
        }, 250);
        const id = event.target.dataset.productId;
        const $cartItem = this.$cartItems.filter('[id="' + id + '"]');
        const $productTitle = $cartItem.find(SELECTORS.PRODUCT_TITLE).text();

        const productCode = event.target.dataset.productCode;
        const accessoryCode = event.target.dataset.accessoryCode;
        const updateObject = {};
        updateObject.productCode = productCode;
        
        updateObject.qty = this.findPropById(id, this.cartModel.removedItemArray, 'qty');
        updateObject.productId = id;
        if (accessoryCode !== "") {
            updateObject.accessoryCode = accessoryCode;
        }

        try {
            const response = await this.cartService.addToCart(updateObject);
            if (!response.success && response.statuscode == 500) {
                return this.notifications.showErrorNotification(response.error, ALERT_MESSAGE_CLASS);
            }

            /* Removing loading classes */
            $target.removeClass(LOADING_CLASS);

            this.updateNavigationView(productCode, updateObject.qty);

            // Capture the new entry group number to be used with subsequent updates
            const updatedEntry = response.response.Entries.find((entry) => {
                if (entry.Product.ProductCode == productCode
                    && ((accessoryCode && entry.HasProductReference && entry.Product.ProductReference.ProductCode == accessoryCode)
                        || (!accessoryCode && !entry.HasProductReference)))
                    return entry;
            });
            if (updatedEntry) {
                updateObject.entryGroupNumber = updatedEntry.EntryGroupNumbers[0];
            }

            this.cartModel.updateCartArray(id, updateObject);

            $cartItem.removeClass(CLASSES.REMOVED_ITEM_CLASS);
            $cartItem.find(SELECTORS.MSG_DISPLAY).removeClass(IS_HIDDEN)
            this.createDynamicChildren(); /* Reestablishing active children after removal */

            /* Removing item from "removed" array and  */
            this.cartModel.locateAndRemoveUndoItem(updateObject);
            this.cartModel.updateTrackingArray(id, updateObject.qty);

            // Add value to input with last saved amount
            this.updateSubtotal(response.response.SubTotal);
            this.updateDiscountTotal(response.response.DiscountTotal);
            this.updateCartTotal(response.response.TotalQty);
            this.hideExistingErrorOrNot();
            if (!response.success) { /* For successful "failures" where a user can't have the exact quantity requested */
                this.notifications.showErrorNotification(response.error, ERROR_MESSAGE_CLASS);
                this.$quantityInputs.filter('[data-product-id="' + id + '"]')[0].value = response.qtyAdded;
            } else {
                this.$quantityInputs.filter('[data-product-id="' + id + '"]')[0].value = updateObject.qty;
            }
            setTimeout(() => {
                this.$ariaUpdate.text($productTitle + ': ' + NOTIFICATIONS.ITEM_UNDO_REMOVAL + ' ' + this._provideCartTotalsUpdate());
            }, 500);
        } catch (e) {
            setTimeout(() => {
                this.notifications.showErrorNotification(NOTIFICATIONS.FETCH_FAILED, ALERT_MESSAGE_CLASS);

                /* Removing loading classes */
                $target.removeClass(LOADING_CLASS);
                this.$ariaUpdate.text('');
                this.createDynamicChildren();
            }, 500)
        }
    }

    onCheckoutClick(e) {
        /* Preventing default link behavior in order to do our cart checks before manually sending user to checkout */
        e.preventDefault();
        const href = e.target.href;
        let checkoutError = false
        if (this.cartIsEmpty()) {
            console.info('cart is empty');
            this.notifications.showErrorNotification(NOTIFICATIONS.EMPTY_CART);
            return;
        }
        this.$quantityInputs.each((_, node) => {
            const { qtyInStock, isOutOfStock } = node.dataset

            if ( isOutOfStock.toLowerCase()  === 'true' ) {
                this.notifications.showErrorNotification(outOfStockErrors({message: NOTIFICATIONS.OUT_OF_STOCK_ERROR}), CLASSES.SITE_MESSAGE_ERROR)
                $(node).parents(SELECTORS.CART_TABLE_ROW_CELL_CONTENT).find(SELECTORS.ITEM_OUT_OF_STOCK_INLINE_ERROR).removeClass(IS_HIDDEN);
                checkoutError = true
            } else if ( node.dataset.maxOrderQuantity && parseInt(node.value) > parseInt(node.dataset.maxOrderQuantity) ) {
                this.$checkout.prop('disabled', true);
                this.notifications.showErrorNotification(outOfStockErrors({message: NOTIFICATIONS.MORE_THAN_MAX_ORDERED_QUANTITY}), CLASSES.SITE_MESSAGE_ERROR);
                checkoutError = true;
            } else if ( parseInt(node.value) > parseInt(qtyInStock) ) {
                const inlineErrorNode = $(node).parents(SELECTORS.CART_TABLE_ROW_CELL_CONTENT).find(SELECTORS.ITEM_IN_STOCK_INLINE_ERROR)
                inlineErrorNode.text(`Only ${qtyInStock} items in-stock.`)
                inlineErrorNode.removeClass(IS_HIDDEN);
                $(node).addClass(CLASSES.INPUT_QTY_ERROR);
                checkoutError = true;
            }
        })

        if (checkoutError) {
            // this.notifications.showErrorNotification(outOfStockErrors({message: NOTIFICATIONS.OUT_OF_STOCK_ERROR}), CLASSES.SITE_MESSAGE_ERROR)
            // Need to refresh the page in order to remove disabled state of button.
            $(e.target).attr('disabled', true);
            return;
        }
        const arrayOfChangedItems = this.getUnsavedItemChanges();
        if (arrayOfChangedItems.length) {
            const templateData = {
                notificationMessage: NOTIFICATIONS.FORGOT_TO_SAVE,
                product: arrayOfChangedItems
            };
            this.notifications.showErrorNotification(cartItemErrors(templateData));
            console.info('there are changed items, ', arrayOfChangedItems);
            return;
        }
        $(e.currentTarget).addClass(LOADING_CLASS);
        this.cartData.SubTotal = this.$subtotal.text();
        this.trackingService.beginCheckout(this.cartData);
        window.location = href;
    }

    getUnsavedItemChanges() {
        let changedItems = [];
        for (let i = 0; i < this.cartModel.changeTrackingArray.length; i++) {
            const unsavedArray = this.cartModel.changeTrackingArray;
            const savedArray = this.cartModel.cartArray;

            if (this.cartModel.removedItemArray.length) { /* Skip iteration if item was removed by user */
                let skipThisLoop = false;
                for (let j = 0; j < this.cartModel.removedItemArray.length; j++) {
                    if (this.cartModel.removedItemArray[j].id === unsavedArray[i].id) {
                        skipThisLoop = true;
                    }
                }
                if (skipThisLoop) {
                    continue;
                }
            }
        
            if (unsavedArray[i].qty !== savedArray[i].qty) {
                var cartItemElements = this.$activeCartItems.filter(`[id=${savedArray[i].id}]`).find(SELECTORS.PRODUCT_TITLE)
                if (cartItemElements.length > 1) {
                    var elementNames = [];
                    Object.entries(cartItemElements).forEach(([key, value]) => {
                        let keyType = parseInt(key);
                        if (!isNaN(keyType)) {
                            elementNames.push(value.innerText);
                        }
                        
                    });
                    const item = {};
                    item.id = savedArray[i].id;
                    item.title = elementNames;
                    changedItems.push(item);
                } else {
                    const prodTitle = this.$activeCartItems.filter(`[id=${savedArray[i].id}]`).find(SELECTORS.PRODUCT_TITLE).text();
                    const item = {};
                    item.id = savedArray[i].id;
                    item.title = prodTitle;
                    changedItems.push(item);
                }
            }
            }        
        return changedItems;
    }

    updateSubtotal(val) {
        this.$subtotal.text(val);
        this.ariaSubtotal = val;
        return this;
    }

    updateDiscountTotal(val) {
        this.$discountTotal.text(val);
        this.ariaDiscounts = val;
        return this;
    }

    cartIsEmpty() {
        if (this.cartModel.cartArray.length === this.cartModel.removedItemArray.length) {
            return true;
        }
        return false;
    }

     updateNavigationView(productCode, newQuantity){
        var cartDataObject = this.cartData.Entries.filter((entry) => {
            return entry.Product.ProductCode == productCode;
        })[0];

        if(cartDataObject){
            var curQuantity = cartDataObject.Product.ProductQuantity;

            if(curQuantity < newQuantity){
                cartDataObject.Product.ProductQuantity = newQuantity - curQuantity;
                this.trackingService.addToCart(cartDataObject.Product);
            }

            if(curQuantity > newQuantity){
                cartDataObject.Product.ProductQuantity = curQuantity - newQuantity;
                this.trackingService.removeFromCart(cartDataObject.Product);
            }
            cartDataObject.Product.ProductQuantity = newQuantity
        }
        
    }

    updateCartTotal(TotalQty) {
        this.$cartCount.text(TotalQty);
        this.ariaCartCount = TotalQty;
        return this;
    }

    enable() {
        this.$quantityInputs.on('change input', this.onQuantityChangeHandler);
        this.$quantityInputs.on('keydown', this.onQuantityKeydownHandler);
        this.$updateLinks.on('click', this.onUpdateClickHandler);
        this.$itemRemovalLinks.on('click', this.onItemRemovalHandler);
        this.$undoRemovalLinks.on('click', this.onUndoRemovalHandler);
        this.$cartEmptyLink.on('click', this.onCartEmptyHandler);
        this.$cartEmptyConfirmLink.on('click', this.onCartEmptyConfirmHandler);
        this.$cartShareLink.on('click', this.onCartShareHandler);
        this.$cartShareCopyUrlLink.on('click', this.onCartShareCopyLinkHandler);
        this.$cartShareSendEmailLink.on('click', this.onCartShareSendEmailHandler);
        this.$cartShareEmailCloseButton.on('click', this.onCartShareSendEmailCloseHandler);
        this.$cartShareEmailSendButton.on('click', this.onCartShareSendEmailSubmitHandler);
        $('html').on('click', this.onClickOutHandler);
        this.$checkout.on('click', this.onCheckoutClickHandler);
        return this;
    }

    disable() {
        this.$quantityInputs.off('change input', this.onQuantityChangeHandler);
        this.$quantityInputs.off('keydown', this.onQuantityKeydownHandler);
        this.$updateLinks.off('click', this.onUpdateClickHandler);
        this.$itemRemovalLinks.off('click', this.onItemRemovalHandler);
        this.$undoRemovalLinks.off('click', this.onUndoRemovalHandler);
        this.$cartEmptyLink.off('click', this.onCartEmptyHandler);
        this.$cartEmptyConfirmLink.off('click', this.onCartEmptyConfirmHandler);
        this.$cartShareLink.off('click', this.onCartShareHandler);
        this.$cartShareCopyUrlLink.off('click', this.onCartShareCopyLinkHandler);
        this.$cartShareSendEmailLink.off('click', this.onCartShareSendEmailHandler);
        this.$cartShareEmailCloseButton.off('click', this.onCartShareSendEmailCloseHandler);
        this.$cartShareEmailSendButton.off('click', this.onCartShareSendEmailSubmitHandler);
        $('html').off('click', this.onClickOutHandler);
        this.$checkout.off('click', this.onCheckoutClickHandler);
        return this;
    }
}